// One-time GPT setup, shared by every AdLoader instance. enableSingleRequest() batches
// ad requests for slots defined/displayed together instead of firing one request per slot,
// and must be called before enableServices() and before any slot is displayed.
let initialized = false;

export function ensureGptReady() {
  if (typeof window === "undefined") return;

  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];

  if (initialized) return;
  initialized = true;

  window.googletag.cmd.push(() => {
    window.googletag.pubads().enableSingleRequest();
    window.googletag.enableServices();
  });
}
